import { z } from "zod";
import { FadeInIntersection } from "@/common/components/fade-in.component";
import { SanitizedContent } from "@/common/components-2/sanitized-content";
import { Section } from "@/common/components-2/section";
import { isNil } from "@/common/helpers/lang";
import type { Homepage } from "@/payload-types";
import { EmitErrorReport } from "@/services/cms/components/emit-error-report";
import { HowItWorksSection } from "./how-it-works-section";
import { firstStepSchema, nextStepSchema } from "./how-it-works-section.schema";
import { HowItWorksWithTabsSection } from "./how-it-works-with-tabs-section";

export function CmsHowItWorksSection({ heading, first, next }: Homepage["his"]) {
  if (isNil(heading)) return null;

  let firstStepData: z.infer<typeof firstStepSchema>;
  let nextStepsData: z.infer<typeof nextStepSchema>[];

  try {
    firstStepData = firstStepSchema.parse(first);
    nextStepsData = z.array(nextStepSchema).parse(next);
  } catch (ex) {
    return <EmitErrorReport name="How it works section" error={JSON.stringify(ex)} />;
  }

  return (
    <>
      <FadeInIntersection rootMargin="0px 0px -300px 0px" delay={100} asChild animation="fadeUp">
        <Section classes={{ container: "py-12 lg:py-20" }}>
          <SanitizedContent as="h2" content={heading} className="mb-8 text-center font-serif text-3xl lg:text-5xl" />
          <HowItWorksWithTabsSection {...firstStepData} />
        </Section>
      </FadeInIntersection>
      <Section>
        <HowItWorksSection steps={nextStepsData} />
      </Section>
    </>
  );
}
